import { render, staticRenderFns } from "./Document.vue?vue&type=template&id=30d56fb2&"
import script from "./Document.vue?vue&type=script&lang=js&"
export * from "./Document.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1339545384/src/github.com/trainn-tech/trainn-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30d56fb2')) {
      api.createRecord('30d56fb2', component.options)
    } else {
      api.reload('30d56fb2', component.options)
    }
    module.hot.accept("./Document.vue?vue&type=template&id=30d56fb2&", function () {
      api.rerender('30d56fb2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/app/components/icons/Document.vue"
export default component.exports